export { default } from './TabEvents';
